"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifiers = void 0;

var react_1 = __importDefault(require("react"));

var styled_components_1 = require("styled-components");

var atoms_utils_theme_1 = require("@lettucegrow/atoms.utils.theme");

var Icon_styled_1 = require("./Icon.styled");

Object.defineProperty(exports, "modifiers", {
  enumerable: true,
  get: function get() {
    return Icon_styled_1.modifiers;
  }
});

var Icon = function Icon(_ref) {
  var modifiers = _ref.modifiers,
      children = _ref.children,
      onClick = _ref.onClick,
      className = _ref.className;
  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: atoms_utils_theme_1.theme
  }, react_1.default.createElement(Icon_styled_1.IconStyled, {
    modifiers: modifiers,
    onClick: onClick,
    tabIndex: onClick ? 0 : -1,
    className: className
  }, children));
};

exports.default = Icon;